import { useEffect, useState } from "react";
import api from "@/lib/api";
import CrudPage from "@/components/CrudPage";
import { useAuth, canWrite } from "@/context/AuthContext";
import { rupiah } from "@/lib/format";

export default function OverheadCost() {
  const { user } = useAuth();
  const [batches, setBatches] = useState(null);

  useEffect(() => {
    api.get("/batches").then((b) => setBatches(b.data)).catch(() => setBatches([]));
  }, []);

  if (!batches) return <div className="text-slate-400 py-20 text-center">Memuat...</div>;

  return (
    <CrudPage
      title="Overhead Cost (BOP)"
      subtitle="Biaya overhead pabrik per batch: listrik, BBM, air, penyusutan, pemeliharaan, QC."
      endpoint="/overhead-costs"
      canWrite={canWrite(user?.role, ["akuntansi"])}
      scope={{ key: "batch_id", placeholder: "Pilih Batch", options: batches.map((b) => ({ value: b.id, label: `${b.no_batch} — ${b.product_name}` })) }}
      columns={[
        { key: "listrik", label: "Listrik", align: "right", render: (r) => rupiah(r.listrik_kwh * r.listrik_tarif) },
        { key: "bbm", label: "BBM", align: "right", render: (r) => rupiah(r.bbm_liter * r.bbm_tarif) },
        { key: "air", label: "Air", align: "right", render: (r) => rupiah(r.air_vol * r.air_tarif) },
        { key: "penyusutan", label: "Penyusutan", align: "right", render: (r) => rupiah(r.penyusutan) },
        { key: "pemeliharaan", label: "Pemeliharaan", align: "right", render: (r) => rupiah(r.pemeliharaan) },
        { key: "qc_lab", label: "QC/Lab", align: "right", render: (r) => rupiah(r.qc_lab) },
        { key: "total", label: "Total BOP", align: "right", render: (r) => rupiah(r.listrik_kwh * r.listrik_tarif + r.bbm_liter * r.bbm_tarif + r.air_vol * r.air_tarif + r.penyusutan + r.pemeliharaan + r.qc_lab) },
      ]}
      fields={[
        { key: "listrik_kwh", label: "Listrik (kWh)", type: "number", step: "0.1" },
        { key: "listrik_tarif", label: "Tarif Listrik (Rp/kWh)", type: "number" },
        { key: "bbm_liter", label: "BBM (liter)", type: "number", step: "0.1" },
        { key: "bbm_tarif", label: "Tarif BBM (Rp/liter)", type: "number" },
        { key: "air_vol", label: "Air (m³)", type: "number", step: "0.1" },
        { key: "air_tarif", label: "Tarif Air (Rp/m³)", type: "number" },
        { key: "penyusutan", label: "Penyusutan Alat (Rp)", type: "number" },
        { key: "pemeliharaan", label: "Pemeliharaan Alat (Rp)", type: "number" },
        { key: "qc_lab", label: "QC/Laboratorium (Rp)", type: "number" },
      ]}
    />
  );
}
